import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as e, isNone as s } from "../../core/maybe.js";
import { onAbort as t, onAbortOrThrow as r, createDeferred as i, isPromiseLike as h, createAbortError as o } from "../../core/promiseUtils.js";
import c from "../../core/Queue.js";
import { schedule as n } from "../../core/scheduling.js";

var u = function u(e, s) {
  _classCallCheck(this, u);

  this.item = e, this.controller = s, this.promise = null;
};

var l = /*#__PURE__*/function () {
  function l(s) {
    _classCallCheck(this, l);

    this._deferreds = new Map(), this._controllers = new Map(), this._processingItems = new Map(), this._isPaused = !1, this._schedule = null, this._task = null, this.concurrency = 1, s.concurrency && (this.concurrency = s.concurrency), this._queue = new c(s.peeker), this.process = s.process;
    var t = s.scheduler;
    s.priority && e(t) && (this._task = t.registerTask(s.priority, this));
  }

  _createClass(l, [{
    key: "destroy",
    value: function destroy() {
      this.clear(), this._schedule && (this._schedule.remove(), this._schedule = null), this._task && (this._task.remove(), this._task = null);
    }
  }, {
    key: "length",
    get: function get() {
      return this._processingItems.size + this._queue.length;
    }
  }, {
    key: "abort",
    value: function abort(e) {
      var s = this._controllers.get(e);

      s && s.abort();
    }
  }, {
    key: "clear",
    value: function clear() {
      this._queue.clear();

      var e = [];
      this._controllers.forEach(function (s) {
        return e.push(s);
      }), this._controllers.clear(), e.forEach(function (e) {
        return e.abort();
      }), this._processingItems.clear(), this._cancelNext();
    }
  }, {
    key: "forEach",
    value: function forEach(e) {
      this._deferreds.forEach(function (s, t) {
        return e(t);
      });
    }
  }, {
    key: "get",
    value: function get(e) {
      var s = this._deferreds.get(e);

      return s ? s.promise : void 0;
    }
  }, {
    key: "isOngoing",
    value: function isOngoing(e) {
      return this._processingItems.has(e);
    }
  }, {
    key: "has",
    value: function has(e) {
      return this._deferreds.has(e);
    }
  }, {
    key: "pause",
    value: function pause() {
      this._isPaused || (this._isPaused = !0, this._cancelNext());
    }
  }, {
    key: "push",
    value: function push(s, h) {
      var _this = this;

      var c = this.get(s);
      if (c) return c;
      var n = new AbortController();
      var u = null;
      h && (u = t(h, function () {
        return n.abort();
      }));

      var _l = function _l() {
        var e = _this._processingItems.get(s);

        e && e.controller.abort(), _(), a.reject(o());
      },
          _ = function _() {
        p.remove(), e(u) && u.remove(), _this._deferreds.delete(s), _this._controllers.delete(s), _this._queue.remove(s), _this._processingItems.delete(s), _this._scheduleNext();
      },
          p = r(n.signal, _l),
          a = i();

      return this._deferreds.set(s, a), this._controllers.set(s, n), a.promise.then(_, _), this._queue.push(s), this._scheduleNext(), a.promise;
    }
  }, {
    key: "last",
    value: function last() {
      return this._queue.last();
    }
  }, {
    key: "peek",
    value: function peek() {
      return this._queue.peek();
    }
  }, {
    key: "popLast",
    value: function popLast() {
      return this._queue.popLast();
    }
  }, {
    key: "reset",
    value: function reset() {
      var e = [];
      this._processingItems.forEach(function (s) {
        return e.push(s);
      }), this._processingItems.clear();

      for (var _i = 0, _e = e; _i < _e.length; _i++) {
        var _s = _e[_i];
        this._queue.push(_s.item), _s.controller.abort();
      }

      this._scheduleNext();
    }
  }, {
    key: "resume",
    value: function resume() {
      this._isPaused && (this._isPaused = !1, this._scheduleNext());
    }
  }, {
    key: "takeAll",
    value: function takeAll() {
      var e = [];

      for (; this._queue.length;) {
        e.push(this._queue.pop());
      }

      return this.clear(), e;
    }
  }, {
    key: "running",
    get: function get() {
      return !this._isPaused && this._queue.length > 0 && this._processingItems.size < this.concurrency;
    }
  }, {
    key: "runTask",
    value: function runTask(e) {
      for (; !e.done && this._queue.length > 0 && this._processingItems.size < this.concurrency;) {
        this._process(this._queue.pop()), e.madeProgress();
      }
    }
  }, {
    key: "_scheduleNext",
    value: function _scheduleNext() {
      var _this2 = this;

      this._task || this._isPaused || this._schedule || (this._schedule = n(function () {
        _this2._schedule = null, _this2._next();
      }));
    }
  }, {
    key: "_next",
    value: function _next() {
      for (; this._queue.length > 0 && this._processingItems.size < this.concurrency;) {
        this._process(this._queue.pop());
      }
    }
  }, {
    key: "_cancelNext",
    value: function _cancelNext() {
      this._schedule && (this._schedule.remove(), this._schedule = null);
    }
  }, {
    key: "_processResult",
    value: function _processResult(e, s) {
      this._canProcessFulfillment(e) && (this._scheduleNext(), this._deferreds.get(e.item).resolve(s));
    }
  }, {
    key: "_processError",
    value: function _processError(e, s) {
      this._canProcessFulfillment(e) && (this._scheduleNext(), this._deferreds.get(e.item).reject(s));
    }
  }, {
    key: "_canProcessFulfillment",
    value: function _canProcessFulfillment(e) {
      return !!this._deferreds.get(e.item) && this._processingItems.get(e.item) === e;
    }
  }, {
    key: "_process",
    value: function _process(e) {
      var _this3 = this;

      if (s(e)) return;
      var t;
      var r = new AbortController(),
          i = new u(e, r);

      this._processingItems.set(e, i);

      try {
        t = this.process(e, r.signal);
      } catch (o) {
        this._processError(i, o);
      }

      h(t) ? (i.promise = t, t.then(function (e) {
        return _this3._processResult(i, e);
      }, function (e) {
        return _this3._processError(i, e);
      })) : this._processResult(i, t);
    }
  }, {
    key: "test",
    get: function get() {
      var _this4 = this;

      return {
        update: function update(e) {
          return _this4.runTask(e);
        }
      };
    }
  }]);

  return l;
}();

export { l as QueueProcessor };